import React from 'react'
import { connect } from 'react-redux'

import ConfirmOrderModal from './ConfirmOrderModal'
import OrderCounterModal from './OrderCounterModal'
import CancelOrderModal from './CancelOrderModal'
import SuccessOrderModal from './SuccessOrderModal'
import ModalError from '../../../../components/Modal/ModalError'
import { MODAL } from '../../../../reduxs'

function OrderModalGroup(props) {
  const {
    language,
    selectedTab,
    setSelectedTab,
    selectedOrderTab,
    orderManagerTab,
    setSelectedOrderTab,
    editOrderText,
    submitOrderText,
    actionExtend,
    colorTheme,
    closeModalError,
  } = props

  return (
    <>
      <OrderCounterModal
        language={language}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        selectedOrderTab={selectedOrderTab}
        orderManagerTab={orderManagerTab}
        setSelectedOrderTab={setSelectedOrderTab}
        editOrderText={editOrderText}
        submitOrderText={submitOrderText}
      />

      <ConfirmOrderModal
        selectedOrderTab={selectedOrderTab}
        language={language}
      />

      <ModalError
        isVisible={actionExtend.isOpenErrorModal}
        language={language}
        onClose={closeModalError}
        colorTheme={colorTheme}
        detail={actionExtend.textModal}
       />

      <CancelOrderModal language={language}/>

      <SuccessOrderModal language={language}/>
    </>
  )
}

const mapStateToProps = ({ accountReducer,  modalReducer}) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
    language: accountReducer.language,
    actionExtend: modalReducer.errorModal,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModalError: () => dispatch(MODAL.action.setErrorModal(false, null)),
  }
}

export default connect(mapStateToProps ,mapDispatchToProps)(OrderModalGroup)
